import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/AuthContext";
import { SettingsProvider } from "@/lib/SettingsContext";
import { ContentAvailabilityProvider } from "@/lib/ContentContext";
import { SoundProvider } from "@/lib/SoundContext";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Books from "@/pages/Books";
import BookDetail from "@/pages/BookDetail";
import Boutique from "@/pages/Boutique";
import Consultations from "@/pages/Consultations";
import Conferences from "@/pages/Conferences";
import Chroniques from "@/pages/Chroniques";
import Presse from "@/pages/Presse";
import Agenda from "@/pages/Agenda";
import Onirotherapie from "@/pages/Onirotherapie";
import Hypnose from "@/pages/Hypnose";
import Mediumnite from "@/pages/Mediumnite";
import Deuil from "@/pages/Deuil";
import HistoireEsoterisme from "@/pages/HistoireEsoterisme";

import Podcast from "@/pages/Podcast";
import Videos from "@/pages/Videos";
import Projets from "@/pages/Projets";
import Reseaux from "@/pages/Reseaux";
import Oracle from "@/pages/Oracle";
import RendezVous from "@/pages/RendezVous";
import Pros from "@/pages/Pros";
import MediaKit from "@/pages/MediaKit";
import Univers from "@/pages/Univers";
import Search from "@/pages/Search";
import VraiCroyanceLegende from "@/pages/VraiCroyanceLegende";
import { MentionsLegales, Confidentialite, Cookies, CGV } from "@/pages/Legal";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import NotFound from "@/pages/NotFound";

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/livres" element={<Books />} />
        <Route path="/livres/:slug" element={<BookDetail />} />
        <Route path="/boutique" element={<Boutique />} />
        <Route path="/consultations" element={<Consultations />} />
        <Route path="/rendez-vous" element={<RendezVous />} />
        <Route path="/conferences" element={<Conferences />} />
        <Route path="/les-chroniques-de-letrange" element={<Chroniques />} />
        <Route path="/presse-medias" element={<Presse />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/onirotherapie" element={<Onirotherapie />} />
        <Route path="/hypnose" element={<Hypnose />} />
        <Route path="/mediumnite" element={<Mediumnite />} />
        <Route path="/deuil" element={<Deuil />} />
        <Route path="/histoire-esoterisme" element={<HistoireEsoterisme />} />
   
        <Route path="/podcast" element={<Podcast />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/projets" element={<Projets />} />
        <Route path="/reseaux-sociaux" element={<Reseaux />} />
        <Route path="/dorothee-ia" element={<Oracle />} />
        <Route path="/oracle" element={<Oracle />} />
        <Route path="/professionnels" element={<Pros />} />
        <Route path="/kit-media" element={<MediaKit />} />
        <Route path="/univers" element={<Univers />} />
        <Route path="/recherche" element={<Search />} />
        <Route path="/vrai-croyance-legende" element={<VraiCroyanceLegende />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <ContentAvailabilityProvider>
              <SoundProvider>
                <AppRouter />
                <Toaster position="top-right" />
              </SoundProvider>
            </ContentAvailabilityProvider>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
